import image1 from '../assets/Speakers/Ahmad Ghazawneh.jpg'
import image2 from '../assets/Speakers/Amir zadeh.jpg'
import image4 from '../assets/Speakers/Eric Dutt.jpg'
import image3 from '../assets/Speakers/Jonas.png'
export default [
   {
   name:"Ahmad Ghazawneh",
   role:'Associate Professor, Halmstad University  IT University of Copenhagen',
   image:image1
   },
   {
     name:'Amir zadeh',
     role:'Senior Consultant at Capgemini and Ph.D. Candidate at University of Gothenburg',
     image:image2
   },
   {
     name:'Jonas Sjöström',
     role:'Associate Professor at Halmstad University',
     image:image3
   },
   {
     name:'Eric Dutt',
     role:'AI Change Agent at AI Swedenn',
     image:image4
   }
]


